import React, { FC } from 'react';
import Modal from '~ComponentsImproved/Modal';
import ModalWrapper from '~ComponentsImproved/Modal/ModalWrapper';
import { useBridgeApi, useButton, useI18n, useLogger } from '~Hooks';
import { BlueButton, Box } from '~Styles';
import RefreshIcon from '~Assets/icons/refresh.svg';

/**
 * If the company data fetch fails in Venue, we need to prompt the user to reload the POS
 */
const NoDataModal: FC = () => {
  const { i18n } = useI18n();
  const logger = useLogger('no-data-modal');
  const bridgeApi = useBridgeApi();

  const reloadAppButton = useButton({
    onClick: () => {
      logger.info('Reloading app from no data modal');
      bridgeApi.reload();
    },
  });

  return (
    <Modal isShowing hide={() => {}} backdropClose={false}>
      <ModalWrapper
        header={{
          title: i18n('NoDataModal.Title'),
          subtitle: i18n('NoDataModal.Subtitle'),
          icon: RefreshIcon,
        }}>
        <Box fluid display="flex" gap="large" marginTop="medium" marginBottom="xs">
          <BlueButton fluid {...reloadAppButton}>
            {i18n('App.Continue')}
          </BlueButton>
        </Box>
      </ModalWrapper>
    </Modal>
  );
};

export default NoDataModal;
